export default __webpack_public_path__ + "static/media/flag-qatar.46f6dba2.svg";